import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { HttpClientService } from '../../../../../core/services/http-client.service';
import type { IncidentStatusClient } from '../../../../../core/tokens/incident-status-client.token';
import { INCIDENTS } from '../../../../../shared/constants/api-routes.constants';
import type {
  IncidentDto,
  IncidentStatusLogDto,
  UpdateIncidentStatusResponse,
} from '../models/incident-status-log.model';

@Injectable({ providedIn: 'root' })
export class IncidentStatusService implements IncidentStatusClient {
  private readonly http = inject(HttpClientService);

  patchIncidentStatus(
    incidentId: number,
    organizationId: number,
    statusApiValue: string,
  ): Observable<UpdateIncidentStatusResponse> {
    return this.http
      .put<IncidentDto>(INCIDENTS.UPDATE(incidentId), {
        organizationId,
        status: statusApiValue,
      })
      .pipe(map((dto) => ({ id: dto.id, status: dto.varianceStatus })));
  }

  getStatusLogs(
    incidentId: number,
    organizationId: number,
  ): Observable<readonly IncidentStatusLogDto[]> {
    const params = new HttpParams().set('organizationId', String(organizationId));
    return this.http.get<IncidentStatusLogDto[]>(INCIDENTS.STATUS_LOGS(incidentId), { params });
  }
}
